import "./styles.css";

import {
  setDragStartCallback,
  setDragMoveCallback,
  setDragEndCallback
} from "./draggable.js";

import circleUrl from "../assets/circle.png";
import sawtoothUrl from "../assets/sawtooth.png";
import squareUrl from "../assets/square.png";
import triangleUrl from "../assets/triangle2.png";

let bt1 = document.getElementById("b1");
let bt2 = document.getElementById("b2");
let bt3 = document.getElementById("b3");
let bt4 = document.getElementById("b4");
let resetBt = document.getElementById("b5");
let undoBt = document.getElementById("b6");
let testClass = document.querySelector(".test");
let target = document.getElementById("target");

let added = [];

let text1 = document.getElementById("text1");
let text1Width = text1.getBoundingClientRect().width;
text1.style.color = "green";
text1.style.left = 40 + text1Width / 2 + "px";
text1.style.top = 80 + "px";

let text2 = document.getElementById("text2");
let text2Width = text2.getBoundingClientRect().width;
text2.style.color = "green";
text2.style.left = 60 + text2Width / 2 + "px";
text2.style.top = 120 + "px";

let text3 = document.getElementById("text3");
let text3Width = text3.getBoundingClientRect().width;
text3.style.color = "green";
text3.style.left = 40 + text3Width / 2 + "px";
text3.style.top = 170 + "px";

let vol = 0;
let fre;

const pitchShift = new Tone.PitchShift().toDestination();
pitchShift.pitch = 0; // down one octave
pitchShift.pitch = -4; // down one octave
const autoFilter = new Tone.AutoFilter().start().toDestination();
autoFilter.type = "triangle17";

const pingPong = new Tone.PingPongDelay("8n", 0.6).toDestination();
const autoPanner = new Tone.AutoPanner("8n").toDestination().start();
const phaser = new Tone.Phaser({
  frequency: 15,
  octaves: 5,
  baseFrequency: 1000
}).toDestination();

const autoWah = new Tone.AutoWah(50, 6, -40).toDestination();
autoWah.Q.value = 10;

bt1.addEventListener("click", function () {
  let circleElement = document.createElement("img");
  circleElement.src = circleUrl;
  circleElement.classList.add("draggable");
  circleElement.classList.add("circle");
  circleElement.style.width = "100px";
  circleElement.style.left = Math.random() * (window.innerWidth - 50) + "px";
  circleElement.style.top = Math.random() * (window.innerHeight - 120) + "px";
  circleElement.style.zIndex = window.last_z;

  target.appendChild(circleElement);
  added.push(circleElement);

  circleElement.osc = new Tone.MonoSynth({
    oscillator: { type: "sine" }
  });
  circleElement.osc.connect(autoPanner);
});

bt2.addEventListener("click", function () {
  let squareElement = document.createElement("img");
  squareElement.src = squareUrl;
  squareElement.classList.add("draggable");
  squareElement.classList.add("square");
  squareElement.style.width = "100px";
  squareElement.style.left = Math.random() * (window.innerWidth - 50) + "px";
  squareElement.style.top = Math.random() * (window.innerHeight - 120) + "px";
  squareElement.style.zIndex = window.last_z;

  target.appendChild(squareElement);
  added.push(squareElement);
  squareElement.osc = new Tone.MonoSynth({
    oscillator: { type: "square" }
  });
  squareElement.osc.volume.value = -30;
  autoWah.Q.value = 2;
  squareElement.osc.connect(autoWah);
});

bt3.addEventListener("click", function () {
  let triangleElement = document.createElement("img");
  triangleElement.src = triangleUrl;
  triangleElement.classList.add("draggable");
  triangleElement.classList.add("triangle");
  triangleElement.style.width = "100px";
  triangleElement.style.left = Math.random() * (window.innerWidth - 50) + "px";
  triangleElement.style.top = Math.random() * (window.innerHeight - 120) + "px";
  triangleElement.style.zIndex = window.last_z;

  target.appendChild(triangleElement);
  added.push(triangleElement);

  triangleElement.osc = new Tone.Synth({
    oscillator: { type: "triangle" }
  });
  triangleElement.osc.connect(pingPong);
});

bt4.addEventListener("click", function () {
  let sawElement = document.createElement("img");
  sawElement.src = sawtoothUrl;
  sawElement.classList.add("draggable");
  sawElement.classList.add("sawtooth");
  sawElement.classList.add("testClass");
  sawElement.style.width = "100px";
  sawElement.style.left = Math.random() * (window.innerWidth - 50) + "px";
  sawElement.style.top = Math.random() * (window.innerHeight - 120) + "px";
  sawElement.style.zIndex = window.last_z;

  target.appendChild(sawElement);
  added.push(sawElement);

  sawElement.osc = new Tone.Synth({
    oscillator: { type: "sawtooth" }
  });
  sawElement.osc.connect(autoFilter);
  // sawElement.osc.type = "sawtooth";
  console.log(testClass);
});

resetBt.addEventListener("click", function () {
  let draggableElements = Array.from(
    document.getElementsByClassName("draggable")
  );
  // console.log(draggableElements);
  draggableElements.forEach((element) => {
    element.remove();

    if (element.osc) {
      element.osc.dispose(); // delete the synth
    }
  });
});

//////////////////////////////////
//////////////////////////////////

let majorNotes = [
  "C3",
  "D3",
  "E3",
  "F3",
  "G3",
  "A3",
  "B3",
  "C4",
  "D4",
  "E4",
  "F4",
  "G4",
  "A4",
  "B4"
];
let Notes2 = ["E2", "E5", "b3", "D4", "C5", "A6", "C3"];

setDragStartCallback(function (element, x, y, scale, angle) {});

setDragMoveCallback(function (element, x, y, scale, angle) {
  vol = (scale - 3) * 4;
  element.osc.volume.value = vol;
  fre = angle * 100 + 100;
  element.osc.frequency.value = fre;
});

document.body.addEventListener("touchstart", (event) => {
  let touches = Array.from(event.touches);
  event.preventDefault();

  touches.forEach((touch) => {
    touch.target.style.transition = "0s filter ease-in-out";
    if (touch.target.classList.contains("draggable")) {
      touch.target.style.filter =
        "drop-shadow(0px 0px 8px rgba(136, 131, 131, 0.8))";
    }

    let randomMajorNotes;
    randomMajorNotes =
      majorNotes[Math.floor(Math.random() * majorNotes.length)];
    console.log(randomMajorNotes);
    // autoWah.Q.value = 2;

    if (touch.target.osc) {
      const now = Tone.now();
      touch.target.osc.triggerAttack(randomMajorNotes, now);
    }
  });
});

document.body.addEventListener("touchend", (event) => {
  let touches = Array.from(event.changedTouches);

  touches.forEach((touch) => {
    touch.target.style.transition = "1s filter ease-in-out";
    touch.target.style.filter = "drop-shadow(0px 0px 0px transparent)";

    if (touch.target.osc) {
      const now = Tone.now();
      touch.target.osc.triggerRelease(now);
    }
  });
});
setDragEndCallback(function (element, x, y, scale, angle) {});
